import { createContext, useContext } from 'react';

import type { TaskView } from '@/lib/api/generated/model';
import type { BoardStepSection } from './boardModel';

/**
 * Every step of the board a card sits on, in board order (spec 125).
 *
 * A card's next action needs the whole board — Start goes to the first step —
 * and threading the list through the column and the draggable wrapper to every
 * card would touch three components for one value. Empty outside a board (the
 * drag overlay's copy, a card rendered alone), where no Start is offered.
 */
const NO_STEPS: readonly BoardStepSection[] = [];

export const BoardStepsContext =
  createContext<readonly BoardStepSection[]>(NO_STEPS);

export function useBoardSteps(): readonly BoardStepSection[] {
  return useContext(BoardStepsContext);
}

/**
 * Move a card to a step without dragging it (spec 262): the card menu's
 * "Move to…" on a phone, through the same checks and undo as a drop. Null
 * outside a board.
 */
export type BoardMove = (task: TaskView, targetStepId: string) => void;

export const BoardMoveContext = createContext<BoardMove | null>(null);

export function useBoardMove() {
  return useContext(BoardMoveContext);
}
